import { Box } from '@mui/material';

const BASE = import.meta.env.BASE_URL;

interface Props {
  /**
   * `phone`: the tree alone, the way into About. `narrow` (600–899px) and
   * `wide` (900px up): the tree and the wordmark on one line.
   */
  variant: 'phone' | 'narrow' | 'wide';
  /** The mark's width, as any CSS length; its height follows. */
  size: string;
  onHome: () => void;
  onAbout: () => void;
}

/** The CommonGround logo, as a button: home on wider screens, About on a phone. */
export default function Lockup({ variant, size, onHome, onAbout }: Props) {
  const phone = variant === 'phone';
  return (
    <Box
      component="button"
      type="button"
      /**
       * On a phone the lockup is the way into About. There is no room in that
       * header for a text link, and "About this project" is the one thing a
       * first-time visitor needs from it; the reset this tap does on wider
       * screens is "Reset all filters", one pull of the sheet away.
       */
      onClick={phone ? onAbout : onHome}
      aria-label={phone ? 'CommonGround — about this project' : 'CommonGround — back to all events'}
      sx={{
        display: 'block',
        width: size,
        minWidth: 0,
        flexShrink: 0,
        appearance: 'none',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        transition: 'opacity 120ms ease',
        '&:hover': { opacity: 0.75 },
      }}
    >
      <Box
        component="img"
        src={`${BASE}${phone ? 'commonground-mark.svg' : 'commonground-logo.svg'}`}
        alt=""
        sx={{ display: 'block', width: '100%', height: 'auto' }}
      />
    </Box>
  );
}
